import { createAsyncThunk } from "@reduxjs/toolkit";
import { walletApi } from "../../api/walletApi";
import { WalletBasicType, WalletDetailsType, WalletTransactionResponseType } from "../../types/walletTypes";
import { AppDispatch, RootState } from "../store";
import { handleRequest } from "../utils/handleRequest";

export const fetchWalletListThunk = createAsyncThunk<
    WalletBasicType[],
    void,
    { dispatch: AppDispatch; state: RootState }
>(
    "wallet/fetchWalletList",
    async (_, { dispatch }) => {
        const result = await handleRequest(
            dispatch,
            "indirect",
            () => walletApi.getCompanyWallets()
        );
        if (result.success()) return result.result as WalletBasicType[];
        throw new Error(result.errorMessage ?? "Failed to fetch wallet list");
    }
);

export const fetchWalletDetailsThunk = createAsyncThunk<
    WalletDetailsType,
    string,
    { dispatch: AppDispatch; state: RootState }
>(
    "wallet/fetchWalletDetails",
    async (walletId, { dispatch }) => {
        const result = await handleRequest(
            dispatch,
            "indirect",
            () => walletApi.getWalletDetails(walletId)
        );
        if (result.success()) return result.result as WalletDetailsType;
        throw new Error(result.errorMessage ?? "Failed to fetch wallet details");
    }
)

export const fetchUserWalletDetailsThunk = createAsyncThunk<
    WalletDetailsType,
    string,
    { dispatch: AppDispatch; state: RootState }
>(
    "wallet/fetchUserWalletDetails",
    async (walletId, { dispatch }) => {
        const result = await handleRequest(
            dispatch,
            "indirect",
            () => walletApi.getUserWalletDetails(walletId)
        );
        if (result.success()) return result.result as WalletDetailsType;
        throw new Error(result.errorMessage ?? "Failed to fetch wallet details");
    }
);

export const fetchWalletTransactionsThunk = createAsyncThunk<
    WalletTransactionResponseType,
    {
        walletId: string;
        offset?: number;
        limit?: number;
        startDate?: string;
        endDate?: string;
        userId?: string;
    },
    { dispatch: AppDispatch; state: RootState }
>(
    "wallet/fetchWalletTransactions",
    async (
        { walletId, offset, limit, startDate, endDate, userId },
        { dispatch }
    ) => {
        const result = await handleRequest(
            dispatch,
            "indirect",
            () => walletApi.getWalletTransactions(walletId, offset, limit, startDate, endDate, userId)
        );
        if (result.success()) return result.result as WalletTransactionResponseType;
        throw new Error(result.errorMessage ?? "Failed to fetch wallet transactions");
    }
);